module.exports = __webpack_public_path__ + "static/media/Police.0c44aa5c.png";